import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var REDUX_MODULE_LOADED = actionTypePrefix + "/REDUX_MODULE_LOADED";
export var STEP_FORWARD = actionTypePrefix + "/STEP_FORWARD";
export var STEP_BACKWARD = actionTypePrefix + "/STEP_BACKWARD";
export var MODAL_MOUNT = actionTypePrefix + "/MODAL_MOUNT";
export var SET_INITIAL_FORM_STATE = actionTypePrefix + "/SET_INITIAL_FORM_STATE";
export var CHANGE_GALLERY_ID = actionTypePrefix + "/CHANGE_GALLERY_ID";
export var CHANGE_GALLERY_CONTENTS = actionTypePrefix + "/CHANGE_GALLERY_CONTENTS";
export var LOAD_GALLERIES = actionTypePrefix + "/LOAD_GALLERIES";
export var LOAD_EMAIL = actionTypePrefix + "/LOAD_EMAIL";
export var LOAD_HAS_WIX_ACCOUNT = actionTypePrefix + "/LOAD_HAS_WIX_ACCOUNT";
export var AGREE_TO_TERMS = actionTypePrefix + "/AGREE_TO_TERMS";
export var CHANGE_FLOW_STATE = actionTypePrefix + "/CHANGE_FLOW_STATE";
export var JUMP_TO_CREATION = actionTypePrefix + "/JUMP_TO_CREATION";
export var SUBMIT_FORM = actionTypePrefix + "/SUBMIT_FORM";
export var ACTIVATE_PORTFOLIO = actionTypePrefix + "/ACTIVATE_PORTFOLIO";
export var LOAD_PREVIEW = actionTypePrefix + "/LOAD_PREVIEW";
export var SHOW_DISCARD_MODAL = actionTypePrefix + "/SHOW_DISCARD_MODAL";
export var HIDE_DISCARD_MODAL = actionTypePrefix + "/HIDE_DISCARD_MODAL";
export var changeGalleryId = createAction(CHANGE_GALLERY_ID, function (galleryId) { return ({ galleryId: galleryId }); });
export var loadGalleries = createAction(LOAD_GALLERIES, function (galleries) { return ({ galleries: galleries }); });
export var changeGalleryContents = createAction(CHANGE_GALLERY_CONTENTS, function (deviations, total) { return ({
    galleryContents: {
        deviations: deviations,
        total: total,
    },
}); });
export var loadEmail = createAction(LOAD_EMAIL, function (email) { return ({
    email: email,
}); });
export var loadHasWixAccount = createAction(LOAD_HAS_WIX_ACCOUNT, function (hasWixAccount) { return ({ hasWixAccount: hasWixAccount }); });
export var agreeToTerms = createAction(AGREE_TO_TERMS, function (hasAgreedToTerms) { return ({ hasAgreedToTerms: hasAgreedToTerms }); });
export var changeFlowState = createAction(CHANGE_FLOW_STATE, function (flowState) { return ({ flowState: flowState }); });
export var jumpToCreation = createAction(JUMP_TO_CREATION, function (formState) { return ({ formState: formState }); });
export var submitForm = createAction(SUBMIT_FORM, function (formState) { return ({
    formState: formState,
}); });
export var loadPreview = createAction(LOAD_PREVIEW, function (previewUrl, siteId) { return ({
    previewUrl: previewUrl,
    siteId: siteId,
}); });
export var hideDiscardModal = createAction(HIDE_DISCARD_MODAL, function () { return ({}); });
export var showDiscardModal = createAction(SHOW_DISCARD_MODAL, function () { return ({}); });
export var modalMount = createAction(MODAL_MOUNT, function () { return ({}); });
export var setInitialFormState = createAction(SET_INITIAL_FORM_STATE, function (initialState) { return initialState; });
export var activatePortfolio = createAction(ACTIVATE_PORTFOLIO, function () { return ({}); });
export var reduxModuleLoaded = createAction(REDUX_MODULE_LOADED, function () { return ({}); });
//# sourceMappingURL=actions.js.map